import * as React from 'react';
import { useEffect } from 'react';

import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { cardCentering } from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import Header from '../../uiParts/Header';
import RegisterCard from '../../uiParts/RegisterCard';

const PublisherRegister: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.publisher.register');
  });

  return (
    <>
      <Header />
      <Typography sx={cardCentering} component="div">
        <RegisterCard screenType={screenType.publisher} />
      </Typography>
    </>
  );
};

export default PublisherRegister;
